import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden" aria-label="加入我们">
      <img
        src="https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20group%20of%20friends%20sitting%20on%20a%20rooftop%20at%20sunset%20reading%20manga%20books%20together%2C%20warm%20orange%20sky%2C%20floating%20paper%20pages%20and%20sparkles%20in%20the%20air%2C%20cozy%20and%20dreamy%20atmosphere%2C%20premium%20anime%20background%20art%2C%20highly%20detailed&width=1600&height=500&seq=manga-cta-001&orientation=landscape"
        alt="与漫画伙伴一起阅读的温暖场景"
        title="土豪漫画网,一起免费看漫画"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40" aria-hidden="true" />
      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-16 text-center md:flex-row md:px-6 md:text-left">
        <div>
          <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">找不到想看的漫画?想找同好一起追更?</h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-50/80">
            土豪漫画网持续收录人气作品,你也可以把想看的漫画告诉我们,让更多读者一起感受热血故事的魅力。
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
          <Link
            to="/about"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-customer-service-2-line" aria-hidden="true" />
            联系我们
          </Link>
          <Link
            to="/category"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            <i className="ri-compass-3-line" aria-hidden="true" />
            逛一逛分类
          </Link>
        </div>
      </div>
    </section>
  );
}